const digest = '7ffd6b00d7de125e3397100bd2a4e7373da3ae3c9ff65b6842d76cd67aa35626';
const css = `._carouselFullHeight_u4xbc_1 .featured-lounge-carousel>div,._carouselFullHeight_u4xbc_1 [id=featured-lounge-carousel-carousel-items]{height:100%!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'carouselFullHeight': '_carouselFullHeight_u4xbc_1' };
export const carouselFullHeight = '_carouselFullHeight_u4xbc_1';
export { css, digest };